// const baseURL = '/api';//本地代理
// const baseURL = 'http://dev-bm-api.cailiangyun.com' //测试环境
const baseURL = 'http://bm-api.cailiangyun.com' //生产环境bm-api.cailiangyun.com

//todo  所有接口路径
export default {
  //uploadFile
  uploadFile: `${baseURL}/manage/resource/upload`,
  //登录
  loginForm: `${baseURL}/auth/oauth/token`,//账号密码登陆
  logout: `${baseURL}/auth/token/logout`,//退出登陆
  getLoginCode: `${baseURL}/admin/app/`,////获取登录验证码
  getRegCode: `${baseURL}/admin/app/app/`,//获取注册验证码
  // reToken: `${baseURL}/auth/token`,//刷新token
  reToken: `${baseURL}/auth/oauth/token`,//刷新token（延长时间）

  rePhone: `${baseURL}/admin/user/phone`,//修改手机号
  rePwd: `${baseURL}/admin/user/password`,//修改密码
  getUserInfo: `${baseURL}/admin/user/info`,//用户信息
  editUserInfo: `${baseURL}/admin/user/id`,//修改个人信息
  getEnterpriseList: `${baseURL}/admin/enterprise/list`, // list列表
  getEnterprise: `${baseURL}/admin/enterprise/`, // 详情

  //todo 数据看板:参数实体DateTime:{startTime:”2022–08-12”,endTime:”2022-08-21”}

  //获取看板统计数据
  getCountBoard: `${baseURL}/data/dataIndex/countBoard`,

  //公司认证
  getAttestationPage: `${baseURL}/admin/enterpriseauth/page`,//公司认证审批分页
  getAttestationDetails: `${baseURL}/admin/enterpriseauth/`,//详情
  getAttestationStart: `${baseURL}/admin/enterpriseauth/start/`,//同意
  getAttestationOut: `${baseURL}/admin/enterpriseauth/out/`,//驳回

  //组织申请审批
  getOrgPage: `${baseURL}/admin/organizationapply/page`,//组织申请审批分页
  orgDetails: `${baseURL}/admin/organizationapply/`,//详情
  agreeOrg: `${baseURL}/admin/organizationapply/agree/`,//同意
  refuseOrg: `${baseURL}/admin/organizationapply/disagree/`,//驳回

  //系统用户管理
  getUserPage: `${baseURL}/admin//user/back/page`,//分页列表
  getUserStart: `${baseURL}/admin/user/start/`,//启用
  getUserStop: `${baseURL}/admin/user/out/`,//停用
  getUserRelieve: `${baseURL}/admin/user/`, //解除关联
  updateUserPlatform: `${baseURL}/admin/user/id`,//修改平台权限
  getUserDetails: `${baseURL}/admin/user/back/`,//获取用户详情

  //系统公司管理
  getCompanyPage: `${baseURL}/admin/enterprise/back/page`,//分页列表

  //banner图配置
  getBannerPage: `${baseURL}/config/banner/list`,//banner图分页
  addBanner: `${baseURL}/config/banner`,//添加banner图
  getBannerId: `${baseURL}/config/banner/`,//根据id获取详情
  editBanner: `${baseURL}/config/banner`,//编辑banner图
  deleteBanner: `${baseURL}/config/banner/`,//删除banner图
  //日志管理
  getRecordPage: `${baseURL}/admin/log/page`,//分页列表

  //页面文档
  getDocumentPage: `${baseURL}/config/document/pages/list`, //页面文档列表
  editDocumentPage: `${baseURL}/config/document/pages`, //编辑文档链接
  queryDocument: `${baseURL}/config/document/pages/`, //根据ID查询

  //说明文档
  getDocumentDescriptionPage: `${baseURL}/config/document/description/list`, //说明文档列表
  editDocumentDescription: `${baseURL}/config/document/description`,// 编辑说明文档
  getDocumentId: `${baseURL}/config/document/description/`,//根据ID查询
  addDocument: `${baseURL}/config/document/description`,//新增标题
  deleteDocument: `${baseURL}/config/document/description/`,//删除标题
  previewDocument: `${baseURL}/config/document/description/list/detail`, //预览

  //文档管理
  getDocumentManagePage: `${baseURL}/config/document/page`,//文档管理列表
  queryDocumentManage: `${baseURL}/config/document/`, //根据ID查询
  queryDocumentType: `${baseURL}/config/document/type`,//查询分类
  addDocumentPage: `${baseURL}/config/document`,// 创建文档
  editDocumentManagePage: `${baseURL}/config/document`, //编辑文档
  disabledDocumentPage: `${baseURL}/config/document/disabled/`, //停用文档
  releaseDocumentPage: `${baseURL}/config/document/release/`, //发布文档
  deleteDocumentPage: `${baseURL}/config/document/`, //删除文档

  //公共接口
  getUserList: `${baseURL}/admin/user/page`,// 用户list列表
  getCompanyList: `${baseURL}/admin/enterprise/list`,//公司list
}



// WEBPACK FOOTER //
// ./src/utils/api.js